import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemLetters extends React.Component {

  render() {
    return (
      <tr>
        <td>
          {this.props.count}
        </td>
        <td>
          {this.props.item.ma}
        </td>
        <td>
          {this.props.item.ten}
        </td>
        <td>
          {this.props.item.linhVucDonThuCha ? this.props.item.linhVucDonThuCha.ten : ''}
        </td>
        <td>
          {this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.text : ''}
        </td>
        <td>
          {this.props.item.moTa}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('LINHVUCDONTHU_THEM') && this.props.item.level < 3 ?
                <Link
                  className="itt-add"
                  onClick={this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)}
                >
                  Thêm lĩnh vực con
                </Link>
              : null
            }
            {
              CheckPermission('LINHVUCDONTHU_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                >
                  Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('LINHVUCDONTHU_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.linhVucDonThuId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemLetters.jsx